<template>
    <div class="dash-sidebar">
        <div class="sidebar-header">
            <div class="icon">
                <i class="fal fa-comment-alt-lines"></i>
            </div>
            <div class="text">Registros de Atendimentos</div>
            <div class="action-reload">
                <ui-button type="button" design="xs " :class="load || reload ? 'line-primary' : 'line'" @click="getActivities">
                    <i class="far" :class="load || reload ? 'fa-ellipsis-h' : 'fa-sync'"></i>
                </ui-button>
            </div>
            <div class="action-close">
                <ui-button type="button" design=" xs default-icon" @click="sidebarToggle">
                    <i class="fal fa-times"></i>
                </ui-button>
            </div>
        </div>
        <div class="sidebar-body scroll-color">
            <ui-timeline v-if="data">
                <ui-timeline-card  v-for="item in data" :key="item.id" :value="item" />
            </ui-timeline>
            <div class="sidebar-load" v-if="reload || load">
                <ui-load-indicator bgColor="#FFF" color="#69D296" :h="60" :stroke="8"></ui-load-indicator>
            </div>
            <div class="no-results" v-if="!data">
                <div class="icon">
                    <i class="fal fa-comment-alt-lines"></i>
                </div>
                <div class="text">Nenhuma atividade encontrada.</div>
            </div>
        </div>
    </div>
</template>

<script>

    import { historical } from '@/services/axios'
    import { uiTimeline, uiTimelineCard } from '@/components/ui'
    import uiLoadIndicator from '@/components/ui/load-indicator'
    import store from '@/store'
    import { uiButton } from '@/components/ui/buttons'
    

    export default {
        components: { uiTimeline, uiTimelineCard, uiLoadIndicator, uiButton},
        data() {
            return {
                data: false,
                load: true,
                reload: false,
            }
        },
        methods: {
            getActivities(){
                this.reload = this.load ? false : true
                historical.getAll(
                    '/all-by-user',
                    {
                        user_id: store.getters.user.id,
                        user_group: store.getters.user.user_group
                    }
                )
                .then( response => {
                    this.load   = false
                    this.reload = false
                    if(response.data.length){
                        this.data = response.data
                        this.id = response.data.id
                    }
                }, error => {
                    console.log(error.response)
                })
            },

            sidebarToggle(){
                this.$root.$emit("sidebar-activities-toggle");
            },
            
            
        },
        created() {
            this.getActivities()
        }
    };

</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>